module.exports = __webpack_public_path__ + "img/12.8df56bd9.png";